import { format } from "date-fns";

export const formatHours = (parsedTime: Date): string => {
  const hours = format(parsedTime, "H");
  if (Number(hours) === 0) return "";
  return `${format(parsedTime, "H")}h`;
};
